
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import {
  moneyType,
  getAdditionalCosts,
} from "@/api/factory-packing-list";
import { getNoWrittenOff } from "@/api/purchase-order";

@Component({
  name: "CreateFee",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "其他费用" }) private title: "";
  @Prop({ default: "" }) private supplierId: "";
  @Prop({ default: "" }) private id: "";
  @Prop({ default: "" }) private status: string;
  @Prop({ default: true }) private getButtonTrue: boolean;

  @Watch("supplierId", { immediate: true })
  private watchId() {
    if (this.supplierId) {
      this.getNoWrittenOff();
    }
  }

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public tableCol = [
    {
      label: "费用类型",
      prop: "typeName",
      key: "typeName",
      type: "cascader",
      placeholder: "请选择",
      clearable: true,
      propsData: { label: "label", checkStrictly: false, value: "value" },
      options: [],
      width: 200,
    },
    {
      label: "金额",
      prop: "amount",
      key: "inquiryReferenceNumber",
      show: true,
      disabled: false,
      type: "inputNumber",
      precision: 2
    },
    {
      label: "关联单据",
      prop: "purchaseOrderId",
      key: "purchaseOrderId",
      show: true,
      disabled: false,
      clearable: true,
      type: "select",
      options: [],
      width: 200,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
      type: "textarea",
      width: 140,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 100,
    },
  ] as any;

  private get canUpdate(): boolean {
    return this.status !== '部分出库'
        && this.status !== '出库待处置'
        && this.status !== '完全出库'
        && this.getButtonTrue;
  }

  private get tableColumns() {
    return this.canUpdate ? this.tableCol : this.tableCol.filter((item) => item.key !== "actions");
  }

  mounted() {
    this.moneyType();
    this.getAdditionalCosts();
  }

  public loading: Boolean = false;
  private async getAdditionalCosts() {
    this.loading = true;
    const res: any = await getAdditionalCosts(this.id);
    this.table.list = res.map((item) => {
      return {
        typeName: [item.deduction ? "扣款" : "补款", item.typeName],
        amount: item.value,
        remark: item.remark,
        purchaseOrderId: item.purchaseOrderId,
        id: item.id || "",
      };
    });
    this.loading = false;
  }

  private async moneyType() {
    const res: any = await moneyType();
    let arr = [];
    for (let key in res) {
      res[key].forEach((item) => {
        item.label = item.desc;
        item.value = item.name;
      });
      arr.push({
        label: key,
        value: key,
        children: res[key],
      });
    }
    this.tableCol[0].options = arr;
  }

  private async getNoWrittenOff() {
    const res: any = await getNoWrittenOff({
      supplierId: this.supplierId,
    });
    let arr = [];
    res.forEach((item) => {
      arr.push({
        label: item,
        value: item,
      });
    });
    this.tableCol[2].options = arr;
  }

  //  删除
  public async handleDelete(scope) {
    this.table.list.splice(scope.$index, 1);
  }

  private handleAdd() {
    // table.list 新增一条记录
    this.table.list.push({
      type: "",
      amount: "",
      remark: "",
    });
  }

  public getAmount() {
    const fillList = this.table.list.filter(item => item.typeName[0] === "补款");
    const deductionList = this.table.list.filter(item => item.typeName[0] === "扣款");
    const fill = fillList.reduce((acc, cur) => acc + cur.amount, 0);
    const deduction = deductionList.reduce((acc, cur) => acc + cur.amount, 0);
    return fill - deduction;
  }
}
